import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyCertificat = createAsyncThunk('/dashboard_detail_company_certificat/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyCertifcatDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyCertificatSlice = createSlice({
    name: 'dashboard_detail_company_certificat',
    initialState: {
        isLoading: false,
        dashboard_detail_company_certificat: []
    },

    /*extraReducers: {
        [getDetailCompanyCertificat.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyCertificat.fulfilled]: (state, action) => {
            state.dashboard_detail_company_certificat = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyCertificat.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyCertificat.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyCertificat.fulfilled, (state, action) => {
                state.dashboard_detail_company_certificat = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanyCertificat.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export default dashboardDetailCompanyCertificatSlice.reducer